"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddressOption = exports.ShippingAddressFlow = exports.ShippingAddressField = void 0;
var ShippingAddressField;
exports.ShippingAddressField = ShippingAddressField;

(function (ShippingAddressField) {
  ShippingAddressField["Address"] = "address";
  ShippingAddressField["Address2"] = "address2";
  ShippingAddressField["City"] = "city";
  ShippingAddressField["Country"] = "country";
  ShippingAddressField["State"] = "state";
  ShippingAddressField["Zipcode"] = "zipcode";
  ShippingAddressField["Phone"] = "phone";
  ShippingAddressField["Company"] = "company";
})(ShippingAddressField || (exports.ShippingAddressField = ShippingAddressField = {}));

var ShippingAddressFlow;
exports.ShippingAddressFlow = ShippingAddressFlow;

(function (ShippingAddressFlow) {
  ShippingAddressFlow["shippingForm"] = "shippingForm";
  ShippingAddressFlow["addressSelectionForm"] = "addressSelectionForm";
})(ShippingAddressFlow || (exports.ShippingAddressFlow = ShippingAddressFlow = {}));

var AddressOption;
exports.AddressOption = AddressOption;

(function (AddressOption) {
  AddressOption["none"] = "none";
  AddressOption["original"] = "original";
  AddressOption["verified"] = "verified";
})(AddressOption || (exports.AddressOption = AddressOption = {}));